import { stepClasses as s, stepIconClasses as o, stepLabelClasses as t } from "@mui/material";
const a = {
  styleOverrides: {
    root: ({ theme: e }) => ({
      [`.${s.root}.${s.completed}`]: {
        [`.${o.root}`]: {
          color: e.palette.success.main
        },
        [`.${t.labelContainer}`]: {
          color: e.palette.text.disabled
        },
        [`.${t.label}`]: {
          color: e.palette.text.disabled
        }
      }
    })
  }
};
export {
  a as stepper
};
//# sourceMappingURL=stepper.mjs.map
